import { ChangeEvent, ForwardedRef, forwardRef, FC, useState, useEffect } from 'react';
import CharacterCount from './CharacterCount/CharacterCount';
import { Container, ErrorText, HelpText, LabelWrapper, StyledInput, StyledLabel, SuccessText } from './Input.styles';
import { InputProps } from './Input.types';

const Input: FC<InputProps> = forwardRef(
  (
    { label, onChange, helpText, errorText, characterLimit, successText, value, id, testId = 'Input', ...props },
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const [inputValue, setInputValue] = useState(value || '');

    useEffect(() => {
      setInputValue(value || '');
    }, [value]);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(event);
      }
      setInputValue(event.target.value);
    };

    return (
      <Container>
        <LabelWrapper>
          <StyledLabel htmlFor={id}>{label}</StyledLabel>
          {helpText ? <HelpText>{helpText}</HelpText> : <></>}
        </LabelWrapper>
        <StyledInput {...props} id={id} ref={ref} onChange={handleChange} value={inputValue} errorText={errorText} data-testid={testId} />
        {characterLimit ? <CharacterCount charactersRemaining={characterLimit - (inputValue?.length || 0)} /> : <></>}
        {errorText ? (
          <ErrorText aria-live='assertive' characterLimit={characterLimit}>
            {errorText}
          </ErrorText>
        ) : (
          <></>
        )}
        {successText ? <SuccessText>{successText}</SuccessText> : <></>}
      </Container>
    );
  }
);

export default Input;
